const textTheme = {
  variants: {
    header: {
      fontFamily: 'Barlow',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '1.4em',
      color: 'white',
      _light: { color: 'texas.bg.900' },
    },
    'header-medium': {
      fontFamily: 'Barlow',
      fontWeight: 'medium',
      textTransform: 'uppercase',
      fontSize: '1.4em',
      _light: { color: 'texas.bg.900' },
    },
    'header-small': {
      fontFamily: 'Barlow',
      fontWeight: 'medium',
      textTransform: 'uppercase',
      fontSize: '1.2em',
      _light: { color: 'texas.bg.900' },
    },
    'tab-header': {
      fontFamily: 'Barlow',
      fontWeight: 'bold',
      fontSize: '1.4em',
    },
    main: {
      color: 'white',
      fontWeight: 'bold',
      _light: {
        color: 'texas.bg.900',
      },
    },
    small: {
      fontSize: '0.9em',
      fontWeight: 'normal',
      color: 'gray.200',
      _light: { color: 'gray.400' },
    },
    sub: {
      color: 'gray.200',
      _light: { color: 'gray.400' },
    },
    subtitle: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: 'gray.300',
      _light: {
        color: 'gray.400',
      },
    },
    note: {
      fontSize: 'xs',
      fontWeight: 'bold',
      color: 'yellow.400',
      _light: { color: 'orange.400' },
    },
    error: {
      color: 'texas.danger.100',
      _light: { color: 'red.600' },
    },
    navbar: {
      color: 'whiteAlpha.900',
    },
    'meta-field': {
      fontSize: '0.9em',
      fontWeight: 'bold',
      color: 'gray.100',
      _light: { color: 'gray.400' },
    },
    light: {
      color: 'gray.400',
      _light: { color: 'gray.500' },
    },
    'configuration-code': {
      fontFamily: 'Barlow',
      fontWeight: 'semibold',
    },
    'configuration-strong': {
      color: 'entityDirectory.text',
      fontWeight: 'semibold',
    },
    'configuration-accent': {
      color: 'entityDirectory.primaryBackground',
      fontSize: '12px',
      lineHeight: '16px',
    },
    'configuration-meta': {
      color: 'entityDirectory.secondaryText',
      fontSize: '12px',
      fontWeight: 'semibold',
      letterSpacing: '0.04em',
    },
    'entity-directory-description': {
      color: 'entityDirectory.mutedText',
      fontFamily: 'instrumentSans',
      fontSize: '13px',
      fontWeight: 'normal',
    },
    'entity-directory-heading': {
      color: 'entityDirectory.text',
      fontFamily: 'barlow',
      fontSize: '2xl',
      fontWeight: 'bold',
    },
    'entity-directory-status-active': {
      color: 'entityDirectory.successText',
      fontSize: '12px',
      lineHeight: 'short',
    },
    'entity-directory-status-inactive': {
      color: 'entityDirectory.archivedText',
      fontSize: '12px',
      lineHeight: 'short',
    },
    'article-management-table-header': {
      color: 'articleManagement.mutedText',
      fontFamily: 'Barlow',
      fontSize: 'xs',
      fontWeight: 'semibold',
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
    },
    'article-management-region-name': {
      fontSize: 'sm',
      fontWeight: 'semibold',
    },
    'article-management-branch': {
      color: 'articleManagement.accent',
      fontFamily: 'Barlow',
      fontSize: 'xs',
      fontWeight: 'semibold',
      textTransform: 'uppercase',
    },
  },
};

export default textTheme;
